import classNames from "classnames";
import _hasIn from "lodash/hasIn";
import { cloneElement, isValidElement } from "react";
import { ICON_TYPE } from "../shared.js";
export function isIconElement(node) {
    if (!isValidElement(node)) {
        return false;
    }
    const element = node;
    return _hasIn(element.type, ICON_TYPE);
}
export function cloneIconElement(node, props) {
    if (!isIconElement(node)) {
        return isValidElement(node) ? cloneElement(node, props) : node;
    }
    const { className, ...restProps } = props;
    const element = node;
    const { props: oldProps } = element;
    const newProps = {
        ...oldProps,
        className: classNames(oldProps.className, className),
        ...restProps,
    };
    return cloneElement(element, newProps);
}
